export default "__VITE_ASSET__CIlTZByG__"